import React from 'react';
import GenericList from 'src/shared/genericList';
import { useTranslation } from 'react-i18next';

export default function FunctionList() {
  const { t } = useTranslation();
  const columns = [
    { field: 'function_id', headerName: 'ID', hide: true },
    {
      field: 'function_name',
      headerName: t('FUNCTION'),
      width: 75,
      editable: true,
      flex: 1,
    },
    {
      field: 'function_order',
      headerName: t('SORT_ORDER'),
      width: 75,
      editable: true,
      flex: 1,
    },
  ];

  return <GenericList objectName={'function'} columns={columns} />;
}
